// SHARED-014: Number and currency formatters

export function formatNumber(n: number): string {
  return n.toLocaleString('en-US');
}

export function formatFlop(n: number): string {
  return `₣ ${formatNumber(n)}`;
}

export function formatAGI(n: number): string {
  return `◈ ${formatNumber(n)}`;
}
